import React, { useState } from "react"

import { L10n } from "@encoway/l10n"

import { TranslationConstants } from "../../constants/translationConstants"
import { DefaultPrimaryButton } from "../DefaultPrimaryButton/DefaultPrimaryButton"
import { LoadConfigurationDialog } from "./LoadConfigurationDialog"

export default function LoadConfigurationButton() {
    const [showDialog, setShowDialog] = useState<boolean>(false)

    return (
        <>
            <DefaultPrimaryButton onClick={() => setShowDialog(true)}>
                {L10n.format(TranslationConstants.Toolbar.BUTTON_LOAD)}
            </DefaultPrimaryButton>
            {showDialog && (
                <LoadConfigurationDialog
                    onCloseDialog={() => setShowDialog(false)}
                />
            )}
        </>
    )
}
